import axios, { AxiosResponse } from 'axios';

import { DutyHourTypesDto } from '../../components/admin-portal/Tables/Settings/DutyHourTypes/types';
import {
  DayCategory,
  DisconnectReason,
  DutyCalculationCodeDto,
  DutyHourTypeDto,
  HourCategory
} from 'components/types';

import {
  ADMIN_SETTINGS_MAINTENANCE_DUTY_CALCULATION_CODES,
  ADMIN_SETTINGS_DUTY_HOUR_TYPES,
  DAY_CATEGORY,
  DISCONNECT_REASONS,
  HOURS_CATEGORY
} from '../endpoints';

export const getDutyHourTypes = () =>
  axios.get<DutyHourTypesDto, AxiosResponse<DutyHourTypesDto>>(
    ADMIN_SETTINGS_DUTY_HOUR_TYPES
  );

export const getDutyHourTypesByDcc = () =>
  axios.get<DutyHourTypesDto, AxiosResponse<DutyHourTypesDto>>(
    ADMIN_SETTINGS_DUTY_HOUR_TYPES,
    { params: { dccSvc: 10 } }
  );

export const getDutyHourTypeById = (rowId?: number | null) =>
  axios.get<DutyHourTypeDto, AxiosResponse<DutyHourTypeDto>>(
    `${ADMIN_SETTINGS_DUTY_HOUR_TYPES}/${rowId}`
  );

export const getDutyCalculationCodes = () =>
  axios.get<DutyCalculationCodeDto[], AxiosResponse<DutyCalculationCodeDto[]>>(
    `${ADMIN_SETTINGS_MAINTENANCE_DUTY_CALCULATION_CODES}?group=duty-hour-types`
  );

export const getHoursCategory = () =>
  axios.get<HourCategory[], AxiosResponse<HourCategory[]>>(HOURS_CATEGORY);

export const getDayCategory = () =>
  axios.get<DayCategory[], AxiosResponse<DayCategory[]>>(DAY_CATEGORY);

export const getDisconnectReasons = () =>
  axios.get<DisconnectReason[], AxiosResponse<DisconnectReason[]>>(
    DISCONNECT_REASONS
  );
